import type { KambiEvent, KambiListView } from '@mobi/api-types/kambi'
import { simpleFetchWithLogging } from '../simpleFetchWithLogging'

export function getEventsForGroupId(groupId: number) {
  return simpleFetchWithLogging<{ events: KambiEvent[] }>(
    `${window._kc.apiOfferingBaseUrl}event/group/${groupId}?includeParticipants=true&lang=en_AU&market=AU`
  )
}

export function getUpcomingEventsForAllSports() {
  return simpleFetchWithLogging<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/all/all/all/all/starting-soon.json?lang=en_AU&market=AU&useCombined=true`
  )
}

export function getLiveEventsForAllSports() {
  return simpleFetchWithLogging<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/all/all/all/all/in-play.json?lang=en_AU&market=AU&useCombined=true&useCombinedLive=true&includeParticipants=true`
  )
}
